/** Приводит type с API к каноническому значению для switch в FieldRenderer. */
export function normalizeFieldType(type: string | null | undefined): string {
  if (type == null) return "";
  return String(type).trim().toLowerCase();
}

const TYPE_ALIASES: Record<string, string> = {
  tel: "phone",
  telephone: "phone",
  mobile: "phone",
  mail: "email",
  "e-mail": "email",
  consent: "privacy",
  pd_consent: "privacy",
  personal_data_consent: "privacy",
  agreement: "privacy",
};

/** Канонический type с учётом распространённых алиасов с API. */
export function resolveFieldType(type: string | null | undefined): string {
  const normalized = normalizeFieldType(type);
  return TYPE_ALIASES[normalized] ?? normalized;
}
